import {Component, Injector} from '@angular/core';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {FieldProps, ResultView} from '@twpub/core/models';
import {ComponentCategory} from '@twpub/core/enums';
import {BaseResultViewComponent} from '@twpub/shared/components/base/base-result-view/base-result-view.component';
import {NgClass} from '@angular/common';
import {FieldRenderComponent, TermRenderComponent} from '@twpub/shared/components/renders';
import {RenderRelationsComponent} from '../render-relations/render-relations.component';
import {MatCard, MatCardSubtitle} from '@angular/material/card';

@Component({
  selector: 'pub-default-result-view',
  templateUrl: './default-result-view.component.html',
  styleUrls: ['./default-result-view.component.scss'],
  standalone: true,
  imports: [NgClass, FieldRenderComponent, RenderRelationsComponent, MatCard, MatCardSubtitle, TermRenderComponent]
})
export class DefaultResultViewComponent extends BaseResultViewComponent {
  constructor(injector: Injector) {
    super(injector);
  }

  static readonly compName = 'Default Result View';
  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;
    override props: FieldProps[] = [];

    constructor() {
      super(DefaultResultViewComponent, 'DefaultResultViewComponent', DefaultResultViewComponent.compName, [ComponentCategory.ResultView]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<ResultView>(DefaultResultViewComponent, this.name, initialConfig);
    }
  }

  hasSelectedTerm = () => !!this.concept?.terms.find(t => t.id === this.termId);
}
